<template>
	<div class="left">
		<div class="top">
			<div class="topbox">
				<div class="car" @click="toCar" :class="$route.path.substr(1)=='car'? 'caractive' : ''">
					<img class="iconfont" src='../../assets/cart.png' />
					<div class="txt">购物车<span class="orange">{{GLOBAL.shoppingCartNumber}}</span></div>
				</div>
				<div class="car" @click="goToOrder()" :class="$route.path.substr(1)=='addOrder'? 'caractive' : ''"
				v-show="$common.hasLimits('addOrder')&&($global.userType==0)">
					<img class="iconfont" src='../../assets/order.png' />
					<div class="txt">新增订货</div>
				</div>
				<div class="car" @click="goToPage()" :class="$route.path.substr(1)=='addCustomer'? 'caractive' : ''"
				v-show="$common.hasLimits('customerAdd')&&($global.userType==0)">
					<img class="iconfont" src='../../assets/customer.png' />
					<div class="txt">新增客户</div>
				</div>
			</div>
		</div>
		<div class="midline"></div>
		<div class="bottom">
			<div class="notice" @click="toSuggest">
				<i class="iconfont" style="font-size:25px" :class="{'active':suggestDialog }">&#xe639;</i>
				<div :class="{'active':suggestDialog }">反馈</div>
			</div>
			<div class="notice" @click="toMy">
				<i class="iconfont" style="font-size:30px;" :class="mylinks.indexOf($route.path.substr(1))== -1 ? '' : 'active'">&#xe612;</i>
				<div style="text-align: center;" :class="mylinks.indexOf($route.path.substr(1))== -1 ? '' : 'active'">{{GLOBAL.name}}</div>
			</div>
		</div>
		<el-dialog :visible.sync="suggestDialog" title="反馈" width="60%">
			<Suggest @close="toSuggest"/>
		</el-dialog>
	</div>
</template>

<script>
import Suggest from '../../views/suggest/index.vue'
	export default {
		components:{
			Suggest
		},
		name: "navTop",
		data() {
			return {
				messagelinks: ['message', 'sysMessageDetail'],
				suggestlinks: ['suggest'],
				setlinks: ['set'],
				visible: false,
				mylinks: ['myInfo'],
				GLOBAL:this.$global,
				suggestDialog : false,
			};
		},
		methods: {
			toMessage() {
				this.$router.push('/message')
			},
			toSuggest() {
				this.suggestDialog = !this.suggestDialog;
			},
			toSet(str) {
				this.$router.push({
					path: '/set',
					query: {
						activeName: str
					}
				})
			},
			toMy() {
				this.$router.push('/myInfo')
			},
			
			toCar(){
				this.$router.push('/car')
			},
			goToPage() {
				if (this.$common.checkLimits("customerAdd")) {
					this.$router.push({
						path: "/addCustomer",
					});
				}
			},
			goToOrder() {
				if (this.$common.checkLimits("addOrder")) {
					this.$router.push("/addOrder");
				}
			},
		},
	};
</script>

<style lang="scss" scoped>
.left {
	background-color: #ffffff;
	width: 100%;
	height: 100%;
	box-sizing: border-box;
	padding-top: 180px;
	box-shadow: 0px 0px 4px 0px rgba(20, 23, 26, 0.3);
	position: relative;
	.top{
		width: 100%;
		height: 65%;
		.topbox{
			height: 100%;
			display: flex;
			align-content: space-around;
			flex-wrap: wrap;
		}
		.car {
			width: 80px;
			height: 80px;
			cursor: pointer;
			.iconfont {
				margin-bottom: 5px;
				width: 35px;
				height: 35px;
				padding: 5px 22.5px;
			}
			.txt{
				font-size: 16px;
				text-align: center;
			}
		}
	}
	.midline{
		margin: 0 10px;
		border-top: 1px solid hsla(212, 11%, 23%, 0.14);
	}
	.bottom {
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		height: 200px;
		.notice {
			width: 100%;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			padding: .14rem 0;
			cursor: pointer;
			border: none;

			.iconfont {
				color: #2c3e50;
				padding: 5px 0;
			}
			div{
				font-size: 16px;
				color: #737980;
			}
		}
	}
	.on {
		background: rgba(41, 46, 51, 0.15);
	}
	.caractive{
		.txt{
			color: #1f8fff;
		}
	}
	.active {
		color: #1f8fff !important;
		.iconfont {
			color: #1f8fff !important;
		}
	}
}
.orange {
	font-size: 16px;
	color: #EC6941;
}
.openchild{
	width: 100%;
}
</style>